import { AxiosError } from 'axios';
import {
  ValidateParcelRequest,
  ValidateParcelResponse,
  ordersApi,
} from '../../services/api/orders'
import { setServiceUnavailableMessage } from '../../store/auth/reducer';
import { useAppDialog } from '../use-app-dialog'
import { useTranslation } from 'react-i18next'
import { AppDialogVariants } from '../../store/app-dialog/types'
import { ApiError } from '../../services/api/api-error-data'
import { useDispatch } from 'react-redux';
import { HTTP_STATUS_CODES } from '../../settings/http';

const useValidateParcel = (errorTitle: string) => {
  const { setAppDialog } = useAppDialog()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const validateParcel = async ({
    weight,
    width,
    length,
    height,
  }: ValidateParcelRequest): Promise<ValidateParcelResponse | null> => {
    try {
      const response = await ordersApi.validateParcelRequest({
        weight,
        width,
        length,
        height,
      })
      return response.data
    } catch (error) {
      const status = (error as AxiosError)?.response?.status || null
      if (status === HTTP_STATUS_CODES.SERVICE_UNAVAILABLE) {
        dispatch(setServiceUnavailableMessage({
          serviceUnavailableMessage: 'Service Unavailable'
        }))
        return null
      }

      setAppDialog({
        isShow: true,
        title: errorTitle,
        variant: AppDialogVariants.error,
        message: new ApiError(error).getErrorMessage(t),
      })
      return null
    }
  }

  return {
    validateParcel,
  }
}

export default useValidateParcel
